import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { confirmListProfileUpdates, getListProfileUpdates } from "./profileUpdateApi";

export const getListProfileUpdatesStore = createAsyncThunk(
  "getListProfileUpdatesStore/profile-update",
  async () => {
    try {
      const response = await getListProfileUpdates()
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const confirmListProfileUpdatesStore = createAsyncThunk(
  "confirmListProfileUpdatesStore/profile-update",
  async (payload: any) => {
    console.log("PAYU", payload);
    
    try {
      const response = await confirmListProfileUpdates(payload)
      console.log("PAYURES", response);
      
      return response;
    } catch (error) {
      throw error;
    }
  }
);


interface IInitialState {
    profileUpdate: any[];
    message: string;
    pageIsLoading: boolean;
    isSuccess: boolean;
    confirmUpdate: any;
    personUpdate: boolean;
    contactUpdate: boolean
  }

const initialState: IInitialState = {
profileUpdate: [],
confirmUpdate: null,
message: "",
pageIsLoading: false,
isSuccess: false,
personUpdate: false,
contactUpdate: false
};


  const profileSlice = createSlice({
    name: "profile",
    initialState: initialState,
    reducers: {
      resetProfileMessage: (state) => {
        state.message = "";
      },
      resetProfileSuccess: (state) => {
        state.isSuccess = false;
      },

      resetStatusUpdate: (state) => {
        state.personUpdate = false;
        state.contactUpdate = false;
      },
    },
    extraReducers: (builder) => {
      // get job reducer
      builder.addCase(getListProfileUpdatesStore.pending, (state) => {
        state.pageIsLoading = true;
      });
      builder.addCase(getListProfileUpdatesStore.fulfilled, (state, action) => {
        if (action.payload.status === 1000) {
          state.profileUpdate = action.payload.data;
          state.isSuccess = true;
          state.pageIsLoading = false;
        } else {
          state.message = "someting went wrong";
          state.pageIsLoading = false;
        }
      });
      builder.addCase(getListProfileUpdatesStore.rejected, (state) => {
        state.message = "someting went wrong on server";
        state.pageIsLoading = false;
      });

      builder.addCase(confirmListProfileUpdatesStore.pending, (state) => {
        state.pageIsLoading = true;
      });
      builder.addCase(confirmListProfileUpdatesStore.fulfilled, (state, action) => {
        if (action.payload.status === 1000) {
          console.log("PAYAYAY",action.payload.data);
          state.personUpdate = action.payload.data.resource === "person" ? true : state.personUpdate
          state.contactUpdate = action.payload.data.resource === "contact" ? true : state.contactUpdate
          state.confirmUpdate = action.payload.data;
          state.isSuccess = true;
          state.pageIsLoading = false;
        } else {
          state.message = "someting went wrong";
          state.pageIsLoading = false;
        }
      });
      builder.addCase(confirmListProfileUpdatesStore.rejected, (state) => {
        state.message = "someting went wrong on server";
        state.pageIsLoading = false;
      });
    },
  });
  
  export const { resetProfileMessage, resetProfileSuccess, resetStatusUpdate } = profileSlice.actions;
  export default profileSlice.reducer;
  